export default __webpack_public_path__ + "static/media/Inter-UI-LightItalic-BETA.d8f9c255.woff";